import { render, staticRenderFns } from "./CarteirasForm.vue?vue&type=template&id=53d9307a&scoped=true"
import script from "./CarteirasForm.vue?vue&type=script&lang=js"
export * from "./CarteirasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9307a",
  null
  
)

export default component.exports